module.exports = __webpack_public_path__ + "static/media/sf-test-17.28502f4e.mp3";